import { donorConstants, apiConstants } from '../constants';
import url from '../../helpers/url';

export const saveDonor = (form) => ({
    type: apiConstants.API,
    payload: {
        url: form.id ?
            url.donor.replace(':donorId', form.id) :
            url.donors,
        method: 'POST',
        body: form,
        request: () => ({ type: donorConstants.SAVING_DONOR_REQUEST }),
        success: (data) => ({ type: donorConstants.SAVING_DONOR_SUCCESS, data }),
        failure: (error) => ({ type: donorConstants.SAVING_DONOR_FAILURE, error }),
        formatData: (data) => ({ form: { ...data[0] }}),
        progress: {
            success: { message: () => 'Saved donor.' }
        }
    }
});

export const deleteDonor = (id) => ({
    type: apiConstants.API,
    payload: {
        url: url.donor.replace(':donorId', id),
        method: 'DELETE',
        request: () => ({ type: donorConstants.DELETE_DONOR_REQUEST }),
        success: (data) => ({ type: donorConstants.DELETE_DONOR_SUCCESS, data }),
        failure: (error) => ({ type: donorConstants.DELETE_DONOR_FAILURE, error }),
        formatData: () => id,
        progress: {
            request: { message: () => 'Deleting donor...' },
            success: { message: () => 'Deleted donor.' }
        }
    }
});

export const loadDonors = () => ({
    type: apiConstants.API,
    payload: {
        url: url.donors,
        request: () => ({ type: donorConstants.LOAD_DONORS_REQUEST }),
        success: (data) => ({ type: donorConstants.LOAD_DONORS_SUCCESS, data }),
        failure: (error) => ({ type: donorConstants.LOAD_DONORS_FAILURE, error })
    }
});

export const loadDonorsWithFilter = ({limit_param, sort_params, offset_param, start_date, end_date, city_of_school, country_of_school, is_recipient_assigned, state_or_province }) => ({
    type: apiConstants.API,
    payload: {
        url: `${url.reportingDonors}?limit_param=${limit_param || ''}&sort_params=${sort_params || ''}&offset_params=${offset_param || ''}&start_date=${start_date || ''}&end_date=${end_date || ''}${city_of_school || ''}${country_of_school || ''}&is_recipient_assigned=${is_recipient_assigned || ''}&state_or_province=${state_or_province || ''}`,
        request: () => ({ type: donorConstants.LOAD_DONORS_REQUEST }),
        success: (data) => ({ type: donorConstants.LOAD_DONORS_SUCCESS, data, startDate:start_date, endDate:end_date }),
        failure: (error) => ({ type: donorConstants.LOAD_DONORS_FAILURE, error })
    }
});



// WEBPACK FOOTER //
// ./src/redux/actions/donor.actions.js